
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-angle-right" })
export default class IconAngleRight extends Vue {}
